import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useGenerationMode } from "@/app";
import { GenerateSongPage } from "@/pages/web/GenerateSongPage";
import { ChatGenerateSongPage } from "@/pages/web/ChatGenerateSongPage";
import { GenerationModeToggle } from "../GenerationModeToggle/GenerationModeToggle";
import styles from "./GenerationRoute.module.scss";
/**
 * Роут /generate-song: по выбранному режиму (GenerationModeProvider) рендерит
 * классический пошаговый экран или чат. Тумблер сверху показываем на узких
 * экранах (мини-апп/мобилка), где нет сайдбара; на десктопе он живёт в сайдбаре.
 */
export const GenerationRoute = (props) => {
    const { generationMode } = useGenerationMode();
    const Page = generationMode === "chat" ? ChatGenerateSongPage : GenerateSongPage;
    return (_jsxs("div", { className: styles.wrap, children: [_jsx("div", { className: styles.topBar, children: _jsx(GenerationModeToggle, { language: props.language }) }), _jsx("div", { className: styles.body, children: _jsx(Page, { ...props }) })] }));
};
